import PropTypes from 'prop-types'

/**
 * @typedef {Object} driversInDriverGroups - Contains driver group ids and its corresponding list of driver ids assigned in each.
 * @example { 1223: ['4534', '6740'], 8581: ['1739'] }
 */
export const driversInDriverGroupsPropType = PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string))
